import React, { useContext,useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import axios from 'axios';
import { AuthContext } from './AuthContext';

export default function Header({ sidebarOpen, setSidebarOpen }) {
  const { user } = useContext(AuthContext);
  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };
  useEffect(() => {
    document.body.classList.toggle('sidebar-collapsed', !sidebarOpen);
  }, [sidebarOpen]);

  const [theme, setTheme] = useState(() =>
    localStorage.getItem('theme') || 'light'
  );

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
  };
  const handleLogout = async (e) => {
    e.preventDefault();
    await axios.get('/api/auth/logout');
    window.location.href = '/login';
  };
  const handleMobileSidebarToggle = () => {
    const sidebar = document.getElementsByClassName("sidebar")[0];
    const body = document.body;

    sidebar.classList.toggle("sidebar-open");
    body.classList.toggle("overlay-active");
  };
  return (
    <div className="navbar-header">
      <div className="row align-items-center justify-content-between">
        <div className="col-auto">
          <div className="d-flex flex-wrap align-items-center gap-4">
            <button type="button" className="sidebar-toggle" onClick={handleSidebarToggle}>
            {sidebarOpen ? (
              <Icon icon="heroicons:bars-3-solid" className="icon text-2xl" />
            ) : (
              <Icon icon="iconoir:arrow-right" className="icon text-2xl" />
            )}
            </button>
            { /*<button type="button" className="sidebar-mobile-toggle" onClick={handleMobileSidebarToggle}>
              <Icon icon="heroicons:bars-3-solid" className="icon" />
            </button>*/ }
            <form className="navbar-search">
              <input type="text" name="search" placeholder="Search" />
              <Icon icon="ion:search-outline" className="icon" />
            </form>
          </div>
        </div>

        <div className="col-auto">
          <div className="d-flex flex-wrap align-items-center gap-3">
            <button onClick={toggleTheme}
              type="button"
              data-theme-toggle
              className="w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
            ></button>

            {/* Language Dropdown */}
            {/* Replace with a LanguageDropdown component */}

            {/* Message Dropdown */}
            {/* Replace with a MessageDropdown component */}

            {/* Notification Dropdown */}
            {/* Replace with a NotificationDropdown component */}

            {/* Profile Dropdown */}
            <div className="dropdown">
              <button
                className="d-flex justify-content-center align-items-center rounded-circle"
                type="button"
                data-bs-toggle="dropdown"
              >
                <img
                  src="/images/user.png"
                  alt="user"
                  className="w-40-px h-40-px object-fit-cover rounded-circle"
                />
              </button>
              <div className="dropdown-menu to-top dropdown-menu-sm">
                <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                  <div>
                    <h6 className="text-lg text-primary-light fw-semibold mb-2">{ user.user.name }</h6>
                    {user.type === 'teacher' && (
                      <span className="text-secondary-light fw-medium text-sm">{ user.user.role_name }</span>
                    )}
                  </div>
                  <button type="button" className="hover-text-danger">
                    <Icon icon="radix-icons:cross-1" className="icon text-xl" />
                  </button>
                </div>
                <ul className="to-top-list">
                  <li>
                    <a
                      className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                      href="/users/view-profile"
                    >
                      <Icon icon="solar:user-linear" className="icon text-xl" /> My Profile
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                      href="/email"
                    >
                      <Icon icon="tabler:message-check" className="icon text-xl" /> Inbox
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                      href="/settings/company"
                    >
                      <Icon icon="icon-park-outline:setting-two" className="icon text-xl" /> Setting
                    </a>
                  </li>
                  <li>
                    <a 
                      className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                      href="#"
                      onClick={async (e) => {
                        e.preventDefault();
                        try {
                          await axios.get('/api/auth/logout');
                          window.location.href = '/';
                        } catch (err) {
                          console.error('Logout failed', err);
                        } 
                      }} >
                      <Icon icon="lucide:power" className="icon text-xl" /> Log Out
                    </a>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}